import __request__ from "routing/request";
export function listTables(data_lake_id, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.datalake/data_lake_tables/list_tables/${data_lake_id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
